import Model from '../../framework/model.js';
import Globals from '../../framework/globals.js';
import JobLocationModel from './job-location-model';

const defaults = {
  isShown: true
}

// JobPostModel
// ============
//
// Model wrapper around the data obtained from SmartRecruiters

export default class JobPostModel extends Model {
  constructor(data = {}) {
    super({data: data, defaults: {}});
  }

  // `getUrl()`
  //
  // Returns a user-accessible job post url. The canonical url contains the job name,
  // but the id-based url is also functional.
  //
  // In theory, we should be hitting the getDetails() results and using the resulting
  // `applyUrl` or `postingUrl`, but that seems like excessive and unnecessary data loading.
  // However,if this breaks, that would be the more reliable route.

  getUrl() {
    return `https://jobs.smartrecruiters.com/FortuneBrands/${this.get('id')}`;
  }

  getBrandLabel() {
    let brand = this.get('customField').find((a) => a.fieldId == Globals.get('customFieldMap.brand'))

    return brand ? brand.valueLabel : '';
  }

  getDepartmentLabel() {
    return this.get('department.label') ? this.get('department.label').replace(/(\w)\/(\w)/gi, '$1 / $2') : this.get('department.label');
  }

  getEmployeeTypeLabel() {
    return this.get('typeOfEmployment.label');
  }

  getLocationLabel() {
    if (this.get('jobLocation')) {
      return this.get('jobLocation').getLabel();
    }
    return 'unmatched';
  }

  // `getDetails()`
  //
  // Returns a Promise of the job post details from SmartRecruiters.
  //
  // This is currently not used, but may become necessary at some point.

  getDetails() {
    return fetch(this.get('ref')).then((response) => response.json).then((data) => {
      this.set('details', data);
      return data;
    })
  }

  getKeywordBlob() {
    return `${this.getBrandLabel()};${this.getEmployeeTypeLabel()};${this.getLocationLabel()};${this.getDepartmentLabel()};${this.get('name')}`;
  }

  isRemote() {
    return this.get('location.remote') || this.get('location.name') == 'Remote' || (this.get('jobLocation') && this.get('jobLocation.id') == JobLocationModel.REMOTE_ID);
  }

  // toCSV() {
  //   let locationName = null;
  //   if (this.get('customField').find((a) => a.fieldId == Globals.get('customFieldMap.siteName'))) {
  //     locationName = this.get('customField').find((a) => a.fieldId == Globals.get('customFieldMap.siteName')).valueLabel;
  //   }
  //   let props = [
  //     this.getUrl(),
  //     this.get('name'),
  //     this.getDepartmentLabel(),
  //     this.getEmployeeTypeLabel(),
  //     this.getBrandLabel(),
  //     locationName,
  //     this.get('location.address'),
  //     this.get('location.city'),
  //     this.get('location.region'),
  //     this.get('location.postalCode'),
  //     this.get('location.country'),
  //     this.get('location.remote')
  //   ]

  //   return props.map((a) => a ? `"${a}"` : a).join(', ');
  // }
}